<template>
  <div>臻途智行管理平台</div>
</template>

<script>
export default {};
</script>

<style>
</style>